// extracted by mini-css-extract-plugin
export default {"creditsList":"Os478N8M","creditAvatar":"_2EBHfvvY","coverImage":"_3cyNydR4","projectCard":"_38mVSIA2"};